import { render, staticRenderFns } from "./PostMap.vue?vue&type=template&id=ffd333fa&"
import script from "./PostMap.vue?vue&type=script&lang=js&"
export * from "./PostMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostMap.vue"
export default component.exports